"use strict";
import flatpickr from "flatpickr";

export const contactForm = (data) => ({
    action: data.action,
    email: data.defaultValues?.email ?? '',
    phoneNumber: data.defaultValues?.phoneNumber ?? '',
    fullName: data.defaultValues?.fullName ?? '',
    dates: data?.dates ?? data.defaultValues?.dates ?? '',
    guests: data.defaultValues?.guests ?? null,
    idPrefix: data?.prefix ?? '',
    message: data.defaultValues?.message ?? '',
    loading: false,
    errorMessage: '',
    form: null,
    success: false,
    init() {
        this.form = this.$el;
        if (this.$el.querySelector(`#${this.idPrefix}dates`)) {
            let defaultDates = null;
            if (this.dates) {
                const dateParts = this.dates.split(" - ");
                if (dateParts.length === 2) {
                    defaultDates = dateParts.map(dateStr => new Date(Date.parse(dateStr)));
                }
            }

            flatpickr(this.$el.querySelector(`#${this.idPrefix}dates`), {
                disableMobile: true,
                mode: 'range',
                showMonths: window.innerWidth >= 768 ? 2 : 1,
                dayIncrement: 2,
                minDate: new Date().fp_incr(1),
                dateFormat: "Y-m-d",
                defaultDate: defaultDates,
                localeDateStringFormat: {
                    month: 'short',
                    day: 'numeric',
                    year: '2-digit'
                },
            })
        }
    },
    async submit() {
        this.loading = true;
        if (!this.form.reportValidity()) {
            this.loading = false;
            return;
        }

        this.response = await (await fetch(this.action, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                email: this.email,
                phone: this.phoneNumber,
                full_name: this.fullName,
                message: this.message,
                dates: this.dates,
                guests: this.guests,

            })
        })).json();

        if (this.response.success) {
            this.success = true;
        } else {
            this.errorMessage = this.response.data;
        }

        this.loading = false;
    }
});